"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRateUpdateAppliedActivityTableData = exports.formatCurrency = exports.currencySymbolMap = void 0;
exports.currencySymbolMap = {
    EUR: '\u20AC',
    USD: '$',
    AED: 'د.إ',
    AFN: '؋',
    AUD: '$',
    AZN: '₼',
    BDT: '৳',
    BGN: 'лв',
    BHD: '.د.ب',
    BND: '$',
    BTC: '฿',
    CAD: '$',
    CHF: 'CHF',
    CNY: '¥',
    CRC: '₡',
    CUP: '₱',
    CZK: 'Kč',
    DKK: 'kr',
    DZD: 'دج',
    EGP: '£',
    FJD: '$',
    GBP: '£',
    GEL: '₾',
    HKD: 'HK$',
    HRK: 'kn',
    HUF: 'Ft',
    IDR: 'Rp',
    ILS: '₪',
    INR: '₹',
    IQD: 'ع.د',
    IRR: '﷼',
    ISK: 'kr',
    JOD: 'JD',
    JPY: '¥',
    KGS: 'лв',
    KHR: '៛',
    KRW: '₩',
    KWD: 'KD',
    LKR: '₨',
    LTL: 'Lt',
    LVL: 'Ls',
    MAD: 'MAD',
    MNT: '₮',
    MXN: '$',
    MYR: 'RM',
    NAD: '$',
    NGN: '₦',
    NPR: '₨',
    NZD: '$',
    OMR: '﷼',
    PGK: 'K',
    PHP: '₱',
    PKR: '₨',
    PLN: 'zł',
    QAR: '﷼',
    RON: 'lei',
    RUB: '₽',
    SAR: '﷼',
    SDG: 'ج.س.',
    SEK: 'kr',
    SGD: '$',
    STD: 'Db',
    THB: '฿',
    TRL: '₤',
    TRY: '₺',
    UAH: '₴',
    VND: '₫',
    XBT: 'Ƀ',
    XPF: '₣',
};
const formatCurrency = (currency) => {
    const currencyCode = currency?.code || 'EUR';
    const currencyValue = currency?.value || 0;
    const currencySymbol = exports.currencySymbolMap[currencyCode] ? exports.currencySymbolMap[currencyCode] : currencyCode;
    const currencyMathSymbol = currencyValue < 0 ? '- ' : '';
    return `${currencyMathSymbol}${currencySymbol} ${Math.abs(Number(currencyValue)).toFixed(2)}`;
};
exports.formatCurrency = formatCurrency;
const getRateUpdateAppliedActivityTableData = (activity) => {
    const headers = ['Line item', 'Quantity', 'Updated buying', 'Updated selling'];
    const updatedRows = activity.appliedChanges?.updated.map((updatedChange) => {
        const lineItemCode = `${updatedChange.new.code}`;
        const quantity = updatedChange.new.quantity?.toString();
        const updatedBuying = (0, exports.formatCurrency)(updatedChange.new.originalUnitPrice);
        const updatedSelling = updatedChange.buyingRateOnly
            ? (0, exports.formatCurrency)(updatedChange.old.unitPrice)
            : (0, exports.formatCurrency)(updatedChange.new.unitPrice);
        return [lineItemCode, quantity, updatedBuying, updatedSelling];
    });
    const addedRows = activity.appliedChanges?.added.map((addedChange) => {
        const lineItemCode = `${addedChange.lineItem.code} (added)`;
        const quantity = addedChange.lineItem.quantity?.toString();
        const updatedBuying = (0, exports.formatCurrency)(addedChange.lineItem.originalUnitPrice);
        const updatedSelling = addedChange.buyingRateOnly ? `0` : (0, exports.formatCurrency)(addedChange.lineItem.unitPrice);
        return [lineItemCode, quantity, updatedBuying, updatedSelling];
    });
    const removedRows = activity.appliedChanges?.removed.map((removedChange) => {
        const lineItemCode = `${removedChange.lineItem.code} (removed)`;
        const quantity = removedChange.lineItem.quantity?.toString();
        const updatedBuying = `0`;
        const updatedSelling = removedChange.buyingRateOnly ? (0, exports.formatCurrency)(removedChange.lineItem.unitPrice) : `0`;
        return [lineItemCode, quantity, updatedBuying, updatedSelling];
    });
    return { columnNames: headers, rows: [...(updatedRows || []), ...(addedRows || []), ...(removedRows || [])] };
};
exports.getRateUpdateAppliedActivityTableData = getRateUpdateAppliedActivityTableData;
//# sourceMappingURL=getRateUpdateAppliedActivityTableData.js.map